<div class="flex justify-center flex-grow">
  <div class="w-full max-w-md bg-white flex flex-col flex-grow">
    @let info = stepInfo();
    @if (info) {
    <p class="mb-4 text-surface-500">
        Step {{ info.current }} of {{ info.total }}
    </p>
    }
    <homey-page-title-layout [centered]="true">
      {{title()}}
    </homey-page-title-layout>

    <div class="flex flex-row gap-1 mb-12 items-center">
      <h2 class="text-center align-middle flex-1" [innerHTML]="subtitle()">
        @if (extraInfo()) {
          <p-button icon="pi pi-info-circle" class="absolute translate-y-[-8px]" [rounded]="true" severity="contrast"
                    [text]="true"
                    (click)="op.toggle($event)">
            <p-popover #op>
              {{ extraInfo() }}
            </p-popover>
          </p-button>
        }
      </h2>
    </div>
    <div class="hidden-without-children text-center mb-4">
      <ng-content select="[description]"/>
    </div>
    <div class="flex flex-col flex-grow">
      <ng-content/>
    </div>
  </div>
</div>
